export default __webpack_public_path__ + "static/media/bill-payment.b938888c.png";